import React, { useState, useRef, useEffect } from 'react';
import '../styles/pages/login.scss';
import authApiService from '../services/authApiService';

import { useRelayEnvironment } from 'react-relay';
import { useNavigate } from "react-router-dom";

// Cookie mgmt packages
import Cookies from 'js-cookie';
import { useCookies } from "react-cookie";
import { updateAxioswithcookie } from '../services/upload-files.service';


function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
      return defaultValue;
    }
    return JSON.parse(stored);

  }

// export default function Login({ setIsAuthenticated, setToken }) {
export default function Login() {
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']); // eslint-disable-line no-unused-vars

    const [usernamevalue, setUsernamevalue] = useState(null);
    const [passwordvalue, setPasswordvalue] = useState(null);

    const [isAuthenticationInProcess, setIsAuthenticationInProcess] = useState(false);

    const [error, setError] = useState(false)
    const usernameRef = useRef()
    const passwordRef = useRef()
    const environment = useRelayEnvironment();

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [updateUserDetails, setUpdateUserDetails] = useState(false);

    // P3 token for accessing the GraphQL API
    const [p3token, setP3token] = useState(
        getSessionStorageOrDefault('p3token', null)
    );

    // API token for accessing the Workflow and Visualization APIs
    const [apitoken, setApitoken] = useState(
        getSessionStorageOrDefault('apitoken', null)
    );

    // Set the user details
    const [userDetails, setUserDetails] = useState(
        getSessionStorageOrDefault('userDetails', null)
    );
    
    const [usergroups, setUsergroups] = useState(       // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('usergroups', null)
    );

    const [userid, setUserid] = useState(           // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('userid', null)
    );

    function throwError() {
        console.log('throwError')
        setError(true)
        setTimeout(() => {
            setError(false)
        }, 2000);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const curUsername = usernameRef.current.value
        const curPassword = passwordRef.current.value

        if (curUsername !== "" && curPassword !== "") {
            setUsernamevalue(curUsername);
            setPasswordvalue(curPassword);

            setIsAuthenticationInProcess(true);
            } else {
                throwError();
            }
    } // handleSubmit

    useEffect(() => {
        document.title = `Login | Palmona Pathogenomics`
    }, []);

    useEffect(() => {
        if (usernamevalue) {
            sessionStorage.setItem('usernamevalue', JSON.stringify(usernamevalue));
            localStorage.setItem('username', usernamevalue);
        } else if (sessionStorage.getItem('usernamevalue')) {
            setUsernamevalue(JSON.parse(sessionStorage.getItem('usernamevalue')));
        } else {
            setUsernamevalue(null);
        }
    }, [usernamevalue]);

    useEffect(() => {
        if (isAuthenticationInProcess) {
            authApiService.loginUserMutationApi(environment,usernamevalue, passwordvalue).then(async res => {

                if (res.tokenAuth == null) {
                    throwError()
                } else {
                    const token = res.tokenAuth.token;
                    setP3token(token);
                }
            })    
        }
    }, [isAuthenticationInProcess, environment,usernamevalue, passwordvalue]);
    
    useEffect(() => {
        sessionStorage.setItem('p3token', JSON.stringify(p3token));
    }, [p3token]);   

    useEffect(() => {
        sessionStorage.setItem('apitoken', JSON.stringify(apitoken));
    }, [apitoken]);

    useEffect(() => {
        sessionStorage.setItem('userid', JSON.stringify(userid));
    }, [userid]); 

    useEffect(() => {
        sessionStorage.setItem('usergroups', JSON.stringify(usergroups));
    }, [usergroups]);

    useEffect(() => {
        // if (!userDetails || updateUserDetails) {
        if (updateUserDetails) {    
            setUserDetails(getSessionStorageOrDefault('userDetails', null));
        }
    }, [updateUserDetails]);

    // If we have the P3 token, verify it and get the username and API token
    useEffect(() => {

        const logout = () => {
            Cookies.remove('token');
            Cookies.remove('Useraccesstoken');
            localStorage.removeItem('username');
            removeCookie('auth', { path: '/' });
    
            sessionStorage.clear();
            setIsAuthenticated(false);
            navigate('/')
        }

        if (p3token) {
            // retrieve the API token from the GraphQL API
            authApiService.getAllUserTokenQueryApi(p3token).then(response => {

                if (response.length > 0) {
                    const apitk = response[0].token;
                    setApitoken(apitk);
                } else {
                    throwError()                            
                }
            });
        } else {
            logout();
        }
    }, [p3token, navigate, removeCookie]);

    useEffect(() => {
        if (usernamevalue && p3token) {
            // If we have the username and P3 token, get the user details
            //  From the GraphQL API
            authApiService.getAllUserQueryApi(usernamevalue)
                .then(response => {
                    const user = response.allUsers.edges[0].node;

                    sessionStorage.setItem('userDetails', JSON.stringify(user));
                    setUpdateUserDetails(true);

                    const userfname = user.firstName + " " + user.lastName;
                    localStorage.setItem('usernameDisplay', userfname);
                });
        }
    }, [usernamevalue, p3token]);

    useEffect(() => {
        if (userDetails && apitoken && p3token && usernamevalue) {
            sessionStorage.setItem('userid', JSON.stringify(userDetails.id));
    
            Cookies.set('Useraccesstoken', apitoken, { sameSite: 'strict', secure: true });

            // This was where we were navigating to the home page.
            setCookie('auth', apitoken, {
                // path: '/',
                maxAge: 600,
                secure: true,
                sameSite: 'strict'
            });

            setCookie('userid', userDetails.id, {
                secure: true,
                sameSite: 'strict'
            });

            setCookie('userId', userDetails.id, {
                secure: true,
                sameSite: 'strict'
            });

            updateAxioswithcookie(Cookies.get('Useraccesstoken'))

            authApiService.getAllUserExtendedQueryApi()
                .then(response => {
                    const users_groups = [];
                    response.user.groups.edges.forEach(element => {
                        users_groups.push(element.node.id);
                    });

                    sessionStorage.setItem('usergroups', JSON.stringify(JSON.stringify(users_groups)));
                });

            setIsAuthenticated(true);
        }
    }, [userDetails, apitoken, p3token, usernamevalue, setIsAuthenticated, setCookie]);

    // useEffect(() => {
    //     const navigateToHome = () => {
    //         navigate('/');
    //     }
        
    //     if (isAuthenticated) {
    //         navigateToHome();
    //     }
    // }, [isAuthenticated, navigate]);

    return (
        <div className="container login">
            <div className="row">
                <ul className="nav justify-content-end nav-top-bar">
                    &nbsp;
                </ul>
            </div>
            <div className="row">
                <div className="controls d-flex justify-content-center total-wrap">
                    <div className="align-self-center col-4">
                        <h1>Welcome</h1>
                        <form onSubmit={handleSubmit}>
                            <input type="text" placeholder="Username" ref={usernameRef} />
                            <br />
                            <input type="password" placeholder="Password" ref={passwordRef} />
                            <p className='incorrect-password' style={error ? { display: 'block' } : { display: 'none' }}>Incorrect username/password</p>
                            <p className='incorrect-password' style={error ? { display: 'none' } : { display: 'block' }}>&nbsp;</p>
                            <div className="row">
                                <div className="col align-self-center top-buttons">
                                    <button type="submit" className="btn btn-light">
                                        Login
                                    </button>
                                </div>
                            </div>
                            <hr />
                            <div className="row">
                                <div className="col align-self-center">
                                    &nbsp;
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>
        </div>
    );
} // Login